import React from 'react';
import { RecommendedItems } from './RecommendedItems';
export const SupplementaryContent = () => {
    return React.createElement(React.Fragment, null,
        React.createElement(RecommendedItems, null));
};
